var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { isShowFollow: false },
              on: { open: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c(
                "p",
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("blExchangeAppointment.customerNotice"))
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("blExchangeAppointment.confirmReservation"))
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("blExchangeAppointment.dangerousGoodsNotice")
                      )
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("blExchangeAppointment.declarationNotice")
                      ) +
                      "\n          "
                  ),
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.downLoadDangerousGoodsDeclaration },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("blExchangeAppointment.downloadNotice")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("blExchangeAppointment.download")) +
                      "\n        "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-button" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-primary",
                      attrs: { disabled: _vm.buttonDisabled },
                      on: { click: _vm.handleClose },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.buttonText) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }